import { MaximizeIcon } from "lucide-react";
import { FormattedMessage } from "react-intl";
import type { ReportSectionMeta } from "~/api/model";
import { ReportCopyExportActions } from "~/components/ReportCopyExportActions";
import { TabControlBar } from "~/components/TabControlBar";
import { Button } from "~/components/ui/button";

export const ReportActions = ({
  disabled,
  onMaximize,
  reportId,
  reportSections,
  content,
  exportFileName,
  templateName,
  hasDocListSection = false,
}: {
  disabled: boolean;
  onMaximize: () => void;
  reportId?: string;
  reportSections?: ReportSectionMeta[];
  content: string;
  exportFileName: string;
  reportTitle?: string;
  templateName?: string;
  caseInfo?: {
    caseName: string;
    dateOfBirth: string;
    dateOfLoss: string;
    claimNumber: string;
  };
  hasDocListSection?: boolean;
}) => {
  return (
    <TabControlBar>
      <TabControlBar.Group>
        <Button
          variant="ghost"
          size="mini"
          disabled={disabled}
          onClick={onMaximize}
        >
          <MaximizeIcon className="w-4 h-4 mr-2" />
          <FormattedMessage id="common.maximize" defaultMessage="Maximize" />
        </Button>
        <ReportCopyExportActions
          content={content}
          reportId={reportId}
          reportSections={reportSections}
          fileName={exportFileName}
          disabled={disabled}
          buttonSize="mini"
          copyEventName="app/report/copy_all.button/click"
          exportOpenEventName="app/report/export.button/click"
          exportEventName="app/report/export_menu_open/export_action.link/click"
          templateName={templateName}
          exportMode="async"
          hasDocListSection={hasDocListSection}
        />
      </TabControlBar.Group>
    </TabControlBar>
  );
};
